var MultiGeometryViewBase = require('../base/multi-geometry-view-base');
var PolylineView = require('./polyline-view');

var MultiPolygonView = MultiGeometryViewBase.extend({
  GeometryViewClass: PolylineView
});

module.exports = MultiPolygonView;



//////////////////
// WEBPACK FOOTER
// ./~/internal-carto.js/src/geo/geometry-views/leaflet/multi-polyline-view.js
// module id = 1632
// module chunks = 6